export const EXPORT_READINESS_SUMMARY_VALIDATION_ID = 30;

const LEGACY_VALIDATION_ID_ALIASES: Readonly<Record<number, number>> = {
  10: 2,
  9: 8,
  32: 8,
};

export function normalizeValidationId(validationId: number): number {
  return LEGACY_VALIDATION_ID_ALIASES[validationId] ?? validationId;
}
